import $ from "jquery";
import "moment-timezone";
import moment from "moment";
import React, { useEffect, useState, useContext, forwardRef } from "react";
import SessionManager from "../../routes/SessionManager";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DateUtil from "../../util/DateUtil";
import DropdownButton from "../bootstrap4/DropdownButton";
import Loading from "../Loading";
import Toastr from "toastr";
import { Context } from '../../views/app';
import CommonUtils from '../../util/CommonUtils';
import API from '../../service/SiteKickAPIService';

function WorkHrsBreadcumb(props, refs) {

    const AppContext = useContext(Context);
    let sessionMgr = new SessionManager();
    let userObj = sessionMgr.readCookie("user");

    let workDaysDropDown = [
        { value: "0", label: "No weekends", type: "work_days" },
        { value: "6", label: "Saturday", type: "work_days" },
        { value: "7", label: "Sunday", type: "work_days" },
        { value: "6 7", label: "Both", type: "work_days" },
    ];

    // let site_config = {};
    let site_config = { ...DateUtil.getConfiguredWorkHours(userObj.site_selected) };

    let start_time = new Date();
    start_time.setHours(parseInt(site_config.work_hours.work_hours_start.replace(":00", "")));
    start_time.setMinutes(0);

    let end_time = new Date();
    if (site_config.work_hours.work_hours_end === "23:59") {
        site_config.work_hours.work_hours_end = "00:00";
    }
    end_time.setHours(parseInt(site_config.work_hours.work_hours_end.replace(":00", "")));
    end_time.setMinutes(0);

    const [startTime, setStartTime] = useState(start_time);
    const [endTime, setEndTime] = useState(end_time);
    const [siteConfig, setSiteConfig] = useState(site_config);
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState(userObj);
    let workHrsState = { start_time, end_time, site_config };

    let siteTimeRef = {};
    let timezone = user.site_selected.site_iana_timezone ? user.site_selected.site_iana_timezone : moment.tz.guess();

    useEffect(() => {
        $(".datepicker").attr("readonly", "true");
        setInterval(
            function () {
                let timeNow = {
                    siteTime: moment.tz(new Date().getTime(), timezone).format("YYYY-MM-DD HH:mm:ss z")
                };
                if (siteTimeRef) {
                    siteTimeRef.innerText = timeNow.siteTime;
                }
            },
            1000
        );
    }, [siteTimeRef]);

    React.useImperativeHandle(refs, () => ({
        resetWorkHours,
        updateSiteConfig,
        isChanged
    }));

    const isChanged = () => {
        let isModified = false;
        let userObj = { ...user };
        if (siteConfig.work_hours) {
            userObj.site_selected.site_config.work_hours.work_hours_end = siteConfig.work_hours.work_hours_end;
            userObj.site_selected.site_config.work_hours.work_hours_start = siteConfig.work_hours.work_hours_start;
            userObj.site_selected.site_config.work_hours.include_weekends = siteConfig.work_hours.include_weekends;
            if (siteConfig.work_hours.work_hours_end === "23:59") {
                userObj.site_selected.site_config.work_hours.work_hours_end = "00:00";
            }
            setUser(userObj);
            isModified = JSON.stringify(workHrsState.site_config.work_hours) !== JSON.stringify(userObj.site_selected.site_config.work_hours);
            return isModified;
        }
    }

    const handleSelect = obj => {
        var work_hours = { ...siteConfig.work_hours, include_weekends: obj.value };
        setSiteConfig({ work_hours });
    }

    const resetWorkHours = () => {
        let workHoursState = { ...workHrsState };
        setStartTime(new Date(workHoursState.start_time));
        setEndTime(new Date(workHoursState.end_time));
        let site_config = workHoursState.site_config;
        setSiteConfig(site_config);
    }

    const updateSiteConfig = () => {
        let data = {
            form_input: {
                customer_id: user.site_selected.customer_id,
                site_id: user.site_selected.site_id,
                site_config: JSON.stringify(user.site_selected.site_config),
            },
            customer_id: user.customer_id,
            site_id: user.site_selected.site_id,
            user_login: user.user_login,
            user_token: user.user_token,
        };

        setLoading(true);
        CommonUtils.ajax({
            url: API.SITE.CONFIG.UPDATE,
            type: "POST",
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(data),
        }).then(
            (res) => {
                if ((res.status && res.status.code !== 200) || (res.data && !(res.data.site_config || res.data.Attributes.site_config))) {
                    Toastr.error("An error occured ...please try again.", "Error");
                    $("#spinner").toggleClass("d-none");
                    return;
                }
                Toastr.success("Modified successfully", "Status");
                $("#spinner").toggleClass("d-none");
                let site_config = res.data.site_config || res.data.Attributes.site_config;
                let sessionMgr = new SessionManager();
                let userObj = sessionMgr.readCookie("user");
                if (userObj.site_locations) {
                    for (let site of userObj.site_locations) {
                        if (site.site_id === userObj.site_selected.site_id) {
                            site.site_config = site_config;
                        }
                    }
                }
                userObj.site_selected.site_config = site_config;
                setLoading(false);
                setSiteConfig(site_config);
                AppContext.updateUser(userObj);
                $.event.trigger("work_hours_updated");
                $.event.trigger("refresh_notifications");
            },
            (err) => {
                Toastr.error("An error occured ...please try again.", "Error");
                $("#spinner").toggleClass("d-none");
            }
        );
    }

    useEffect(() => {
        isChanged();
        props.disableButtons();
    }, [siteConfig]);

    return (
        <React.Fragment>
            {loading && (<div> <Loading> Saving Work Hours Information ...</Loading> </div>)}
            {!loading && (
                <React.Fragment>
                    <div className='row'>
                        <div className='col-md-4 col-4'>
                            <label>Site Time : </label>
                        </div>
                        <div className='col-md-8 col-8' ref={x => (siteTimeRef = x)}></div>
                    </div>
                    <div className='row mt-1'>
                        <div className='offset-md-4 col-md-8 offset-4 col-8'>
                            <small className='mr-5'>Start Time</small>
                            <small>End Time</small>
                        </div>
                    </div>
                    <div className='row mt-1'>
                        <div className='col-md-4 col-4'>
                            <label>Work Hours : </label>
                        </div>
                        <div className='col-md-8 col-8 d-flex ml-0'>
                            <DatePicker
                                className='datepicker form-control w-75 d-inline mr-1'
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={60}
                                timeCaption='Time'
                                dateFormat='h aa'
                                selected={startTime}
                                selectsStart
                                onChange={startTime => {
                                    let work_hours_start = ("0" + startTime.getHours()).slice(-2) + ":00";
                                    let work_hours_end = endTime.getHours() + ":00";
                                    let end_Time = DateUtil.addHours(startTime, 10);
                                    if (end_Time.getDate() !== startTime.getDate()) {
                                        end_Time.setHours(0);
                                    }
                                    work_hours_end = ("0" + end_Time.getHours()).slice(-2) === "00" ? "23:59" : end_Time.getHours() + ":00";
                                    startTime.setMinutes(0);
                                    end_Time.setMinutes(0);

                                    let work_hours = { ...siteConfig.work_hours, work_hours_start, work_hours_end };
                                    setStartTime(startTime);
                                    setEndTime(end_Time);
                                    setSiteConfig({ work_hours });
                                    $(".datepicker").attr("readonly", "true");
                                }}
                            />
                            <DatePicker
                                className='datepicker form-control w-75 '
                                showTimeSelect
                                showTimeSelectOnly
                                timeIntervals={60}
                                timeCaption='Time'
                                dateFormat='h aa'
                                selected={endTime}
                                timeClassName={() => { }}
                                selectsEnd
                                minTime={moment().startOf("day").toDate()}
                                maxTime={moment().endOf("day").toDate()}
                                onFocus={e => {
                                    setTimeout(() => {
                                        var disableTill = moment(startTime).format("h:00 A");
                                        var els = $(".react-datepicker__time-list-item");
                                        var el = els[0];
                                        if (el && el.innerText === "12:00 AM") {
                                            var parent = $(el).parent();
                                            $(el).appendTo(parent);
                                        }
                                        for (let i = 1; i < els.length; i++) {
                                            let el1 = els[i];
                                            $(el1).addClass("react-datepicker__time-list-item--disabled");
                                            $(el1).off().on("click", () => { return false; });
                                            if (el1.innerText === disableTill) {
                                                break;
                                            }
                                        }
                                    }, 100);
                                }}
                                onChange={endTime => {
                                    endTime.setMinutes(0);
                                    let site_config = { work_hours: { ...siteConfig.work_hours, work_hours_end: ("0" + endTime.getHours()).slice(-2) === "00" ? "23:59" : ("0" + endTime.getHours()).slice(-2) + ":00" }, };

                                    setEndTime(endTime);
                                    setSiteConfig(site_config);
                                    $(".datepicker").attr("readonly", "true");
                                }}
                            />
                        </div>
                    </div>
                    <div className='row mt-3'>
                        <div className='col-md-4 col-4'>
                            <label>Include Weekends : </label>
                        </div>
                        <div className='col-md-8 col-8'>
                            <DropdownButton
                                className='btn btn-sm d-inline dropdown-toggle text-dark'
                                onOptionClick={handleSelect}
                                default={" -- Choose -- "}
                                selected={siteConfig.work_hours.include_weekends}
                                opts={workDaysDropDown}
                                field_attr='value'
                                value_attr='label'
                            />
                        </div>
                    </div>
                </React.Fragment>
            )}
        </React.Fragment>
    );
}

export default forwardRef(WorkHrsBreadcumb);
